import {
  IconBriefcase,
  IconChartBar,
  IconChartLine,
  IconCloud,
  IconDownload,
  IconFlask,
  IconLayoutDashboard,
  IconSparkles,
} from "@tabler/icons-react";

// ADP-167: each nav item carries its ModuleKey — sub-accounts only see granted modules.
export const OVERVIEW_NAV_ITEM = {
  labelKey: "nav.shopOverview",
  to: "/" as const,
  icon: IconLayoutDashboard,
  module: "dashboard" as const,
};

export const AI_OPTIMIZATION_NAV_GROUP = {
  value: "ai-ad-optimization",
  labelKey: "nav.aiOptimization",
  icon: IconSparkles,
};

export const AI_OPTIMIZATION_NAV_ITEMS = [
  { labelKey: "nav.campaigns", to: "/campaigns" as const, module: "campaigns" as const },
  { labelKey: "nav.managedGroups", to: "/managed-groups" as const, module: "ai" as const },
  { labelKey: "nav.portfolios", to: "/portfolios" as const, module: "campaigns" as const },
  { labelKey: "nav.aiOperations", to: "/ai-operations" as const, module: "approvals" as const },
  {
    labelKey: "nav.operatingStrategy",
    to: "/operating-strategy" as const,
    module: "ai" as const,
  },
];

export const STRATEGY_LAB_NAV_GROUP = {
  value: "strategy-lab",
  labelKey: "nav.strategyLab",
  to: "/strategy-lab" as const,
  icon: IconFlask,
  module: "ai" as const,
};

export const STRATEGY_LAB_VIEWS = [
  { value: "library", labelKey: "nav.strategyLibrary" },
  { value: "distill", labelKey: "nav.strategyDistill" },
  { value: "learn", labelKey: "nav.strategyLearn" },
] as const;

export const EXPANSION_NAV_GROUPS = [
  {
    value: "efficiency-tools",
    labelKey: "nav.efficiencyTools",
    icon: IconBriefcase,
    items: [
      { labelKey: "nav.labels", feature: "labels" },
      { labelKey: "nav.keywordManagement", feature: "keyword-management" },
      { labelKey: "nav.rankMonitoring", feature: "rank-monitoring" },
      { labelKey: "nav.assetManagement", feature: "asset-management" },
    ],
  },
  {
    value: "data-insights",
    labelKey: "nav.dataInsights",
    icon: IconChartBar,
    items: [
      { labelKey: "nav.allProducts", to: "/all-products" as const },
      { labelKey: "nav.productList", feature: "product-list" },
      { labelKey: "nav.advertiserOverview", feature: "advertiser-overview" },
      { labelKey: "nav.customReports", feature: "custom-reports" },
      { labelKey: "nav.brandMetrics", feature: "brand-metrics" },
      { labelKey: "nav.marketInsights", feature: "market-insights" },
      { labelKey: "nav.searchQueryInsights", feature: "search-query-insights" },
      { labelKey: "nav.dataHub", feature: "data-hub" },
    ],
  },
  {
    value: "amc-data-studio",
    labelKey: "nav.amcDataStudio",
    icon: IconCloud,
    items: [
      { labelKey: "nav.amcModels", to: "/amc/models" as const },
      { labelKey: "nav.amcAudiences", to: "/amc/audiences" as const },
    ],
  },
] as const;

export const BUDGET_NAV_ITEM = {
  labelKey: "nav.budgetPlanning",
  to: "/budget-planning" as const,
  icon: IconChartLine,
  module: "dashboard" as const,
};

export const DOWNLOAD_NAV_ITEM = {
  labelKey: "nav.downloadCenter",
  to: "/coming-soon/$feature" as const,
  params: { feature: "download-center" },
  icon: IconDownload,
};

/** Header breadcrumb title for the current route, from the same entries the sidebar renders. */
export function resolveNavTitleKey(pathname: string): string | null {
  if (pathname === "/") return OVERVIEW_NAV_ITEM.labelKey;
  const sections = [
    ...AI_OPTIMIZATION_NAV_ITEMS,
    { labelKey: STRATEGY_LAB_NAV_GROUP.labelKey, to: STRATEGY_LAB_NAV_GROUP.to },
    BUDGET_NAV_ITEM,
    { labelKey: "nav.settings", to: "/settings" },
  ];
  const section = sections.find((item) => pathname.startsWith(item.to));
  if (section) return section.labelKey;
  for (const group of EXPANSION_NAV_GROUPS) {
    for (const item of group.items) {
      const match =
        "to" in item ? pathname.startsWith(item.to) : pathname === `/coming-soon/${item.feature}`;
      if (match) return item.labelKey;
    }
  }
  if (pathname === `/coming-soon/${DOWNLOAD_NAV_ITEM.params.feature}`) {
    return DOWNLOAD_NAV_ITEM.labelKey;
  }
  return null;
}
